import { Injectable } from '@angular/core';
import { Orgfile } from '@src/app/components/filelist/model/orgfile';
import { Tag } from '@src/app/models/tag';
import { Task } from '@src/app/models/task';
import { BehaviorSubject, Subject } from 'rxjs';
import { ETNotification } from './model/ETnotification';
import { Orgstyle } from './model/orgstyle';
import { SessionHelper } from '../sessionHelper';

@Injectable({
  providedIn: 'root'
})
export class UieventhubService {
  private chattask = new Subject<string>();
  private showNotification = new Subject<string>();
  private currentOrg = new Subject<string>();
  private closechat = new Subject<string>();
  private currentProject = new Subject<string>();
  private currentProjectStateChange = new Subject<string>();
  private notifications = new Subject<ETNotification>()
  private projectsFilterType = new Subject<string>();
  private tagFilterApplied = new BehaviorSubject<Tag[]>([]);
  private projectComments = new Subject<string>();
  private dynamicStyle = new BehaviorSubject<Orgstyle>(new Orgstyle);
  private portalView = new Subject<string>();
  private addTask = new Subject<Task>();
  private removeTask = new Subject<Task>();
  private removeFile = new Subject<Orgfile>();
  private showOrgChooser = new Subject<boolean>();
  private showProjectListFilter = new Subject<boolean>();
  private showchatcollapse = new Subject<boolean>();
  private showLoader = new Subject<boolean>();
  private loaders = new BehaviorSubject<string[]>([]);
  private showAsCustomer= new Subject<string>();
  private customerLogoChange = new Subject<string>();
  private currentProjectAssign = new Subject<string>();
  private projectDataLoading = new BehaviorSubject<boolean>(false);
  private editTask = new BehaviorSubject<Task>(new Task);

  constructor() {
    this.showAsCustomer.next(SessionHelper.getCustomer() ? JSON.parse(SessionHelper.getCustomer()).customerId : null);
    this.showchatcollapse.next(SessionHelper.getChatShow() ? true : false);
   }

  chatTask$ = this.chattask.asObservable();
  showNotification$ = this.showNotification.asObservable();
  currentOrg$ = this. currentOrg.asObservable();
  closechat$ = this. closechat.asObservable();
  currentProject$ = this. currentProject.asObservable();
  currentProjectStateChange$ = this.currentProjectStateChange.asObservable();
  notifications$ = this.notifications.asObservable();
  projectsFilterType$ = this.projectsFilterType.asObservable();
  tagFilterApplied$ = this.tagFilterApplied.asObservable();
  projectComments$ = this.projectComments.asObservable();
  dynamicStyle$ = this.dynamicStyle.asObservable();
  portalView$ = this.portalView.asObservable();
  addTask$ = this.addTask.asObservable();
  removeTask$ = this.removeTask.asObservable();
  removeFile$ = this.removeFile.asObservable();
  showOrgChooser$ = this.showOrgChooser.asObservable();
  showProjectListFilter$ = this.showProjectListFilter.asObservable();
  showchatcollapse$ = this.showchatcollapse.asObservable();
  showLoader$ = this.showLoader.asObservable();
  loaders$ = this.loaders.asObservable();
  showAsCustomer$ = this.showAsCustomer.asObservable();
  customerLogoChange$ = this.customerLogoChange.asObservable();
  currentProjectAssign$ = this.currentProjectAssign.asObservable();
  projectDataLoading$ = this.projectDataLoading.asObservable();
  editTask$ = this.editTask.asObservable();

  setEditTask(task: Task) {
   //console.log('setEditTask',task);
    this.editTask.next(task);
  }

  setProjectDataLoading(loading:boolean){
    this.projectDataLoading.next(loading);
  }
  getProjectDataLoading(){
    return this.projectDataLoading.getValue();
  }
  
  setChatTask(taskId: string) {
    this.chattask.next(taskId);
  }
  setShowNotification(show: string) {
    this.showNotification.next(show);
  }
  setCurrentOrg(orgId: string) {
    this.currentOrg.next(orgId);
  }
  setCloseChat(msg: string) {
    this.closechat.next(msg);
  }
  setCurrentProject(projectId: string) {
    this.currentProject.next(projectId);
  }
  setCurrentProjectStateChange(projectId: string) {
    this.currentProjectStateChange.next(projectId);
  }
  setNotification(notifi:ETNotification){
    this.notifications.next(notifi);
  }
  setProjectsFilterType(type:string){
    this.projectsFilterType.next(type);
  }
  setTagFilterApplied(tags:Tag[]){
    this.tagFilterApplied.next(tags);
  }
  setProjectComments(projectId:string){
    this.projectComments.next(projectId);
  }
  setDynamicStyle(style:Orgstyle){
    this.dynamicStyle.next(style);
  }
  setPortalView(type:string){
    this.portalView.next(type);
  }
  setAddTask(atask:Task){
    this.addTask.next(atask);
  }
  setRemoveTask(rtask:Task){
    this.removeTask.next(rtask);
  }
  setRemoveFile(rfile:Orgfile){
    this.removeFile.next(rfile);
  }
  setShowOrgChooser(show:boolean){
    this.showOrgChooser.next(show);
  }
  setShowProjectListFilter(show:boolean){
    this.showProjectListFilter.next(show);
  }
  setshowchatcollapse(show:boolean){
    this.showchatcollapse.next(show);
  }
  setShowLoader(show:boolean){
    this.showLoader.next(show);
  }
  addLoader(loader:string){
    //add new item to the loaders array
    //console.log('adding loader',loader);
    let currentLoaders = this.loaders.getValue();
    currentLoaders.push(loader);
    this.loaders.next(currentLoaders);
    //console.log('current loader (add)',currentLoaders);
  }
  removeLoader(loader:string){
    //remove item from loaders array
   //console.log('removing loader',loader);
    let currentLoaders = this.loaders.getValue();
    currentLoaders = currentLoaders.filter(l => l !== loader);
    
    this.loaders.next(currentLoaders);
    
   //console.log('current loaders (remove)',currentLoaders);
  }
  getLoaders(){
    return this.loaders.getValue();
  }
  clearLoaders(){
    this.loaders.next([]);
    //console.log('current loaders (clear)',this.loaders.getValue());
  }

  setViewAsCustomer(show:string){
    this.showAsCustomer.next(show);
  }
  setCustomerLogoChange(customerId:string){
    this.customerLogoChange.next(customerId);
  }
  setAssignProject(projectId:string){
    this.currentProjectAssign.next(projectId);
  }
}
